<template>
  <div class="lesson-video-player">
    <video
      controls
      crossorigin
      id="lesson-video-player"
      key="complex"
      class="w-100"
    />
  </div>
</template>

<script>
import Hls from "hls.js";
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import get from "lodash/get";
import isMobile from "ismobilejs";

export default {
  props: {
    lesson: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      player: null,
      playerOptions: {
        autoplay: false,
        invertTime: false,
        i18n: {
          speed: "Velocidade",
          quality: "Qualidade",
          qualityLabel: {
            0: "Auto"
          }
        },
        speed: {
          selected: 1,
          options: [0.5, 0.75, 1, 1.25, 1.5, 1.75, 2, 3]
        }
      }
    };
  },
  mounted() {
    const video = document.getElementById("lesson-video-player");

    if (video.canPlayType("application/vnd.apple.mpegURL")) {
      let source = document.createElement("source");
      source.src = this.lesson.stream_url;
      source.type = "application/vnd.apple.mpegURL";
      video.appendChild(source);
    } else if (Hls.isSupported()) {
      var config = {
        xhrSetup: function(xhr, url) {
          xhr.withCredentials = false;
        },
        autoStartLoad: false
      };

      const hls = new Hls(config);
      hls.loadSource(this.lesson.stream_url);

      hls.on(Hls.Events.MANIFEST_PARSED, function() {
        hls.startLoad();
      });

      hls.on(Hls.Events.MANIFEST_PARSED, () => {
        const availableQualities = hls.levels.map(l => l.height).reverse();
        this.playerOptions.quality = {
          default: 0,
          options: [0, ...availableQualities],
          forced: true,
          onChange: e => updateQuality(e)
        };
        this.initPlayer();
      });

      const updateQuality = newQuality => {
        if (newQuality === 0) {
          hls.currentLevel = -1;
        } else {
          hls.levels.forEach((level, levelIndex) => {
            if (level.height === newQuality) {
              hls.currentLevel = levelIndex;
            }
          });
        }
      };

      hls.attachMedia(video);
    }

    let controls = [
      "play-large",
      "play",
      "progress",
      "current-time",
      "mute",
      "volume",
      "captions",
      "settings",
      "pip",
      "airplay"
    ];

    if (!isMobile(window.navigator).any) {
      controls = ["rewind", "fast-forward", ...controls, "fullscreen"];
    }

    this.playerOptions.controls = controls;
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    initPlayer() {
      const video = document.getElementById("lesson-video-player");

      this.player = new Plyr(video, this.playerOptions);

      var firstPlay = true;
      this.player.on("play", () => {
        if (firstPlay) {
          setTimeout(() => {
            this.player.currentTime = get(
              this.lesson,
              "progress.stopped_at",
              0
            );
          }, 1);
          firstPlay = false;
        }
      });

      const saveCurrentPosition = () => {
        this.saveDuration({
          finished: this.player.currentTime === this.duration,
          duration: this.player.currentTime
        });
      };

      this.interval = setInterval(() => {
        if (this.player.playing) {
          saveCurrentPosition();
        }
      }, 20 * 1000);

      this.player.on("pause", saveCurrentPosition);

      this.player.on("ended", event => {
        setTimeout(() => {
          this.saveDuration({ finished: true, duration: 0 });
        }, 200);
      });
    },
    saveDuration({ finished, duration }) {
      this.$store.dispatch("courses/setProgress", {
        lesson: this.lesson.id,
        stopped_at: parseInt(duration),
        finished_at: finished
      });
    }
  }
};
</script>
